import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'
import './index.css'

import dirt from '../images/dirt.png'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Sample' },
        { name: 'keywords', content: 'sample, something' },
      ]}
    />
    <Header siteTitle={data.site.siteMetadata.title} />
    <div
      className="page-wrapper"
      style={{
        backgroundImage: `url(${dirt})`,
      }}
    >
      <div
        style={{
          margin: '0 auto 1.5rem',
          maxWidth: '100%',
          background: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '2px',
          padding: '25px',
          width: 800,
        }}
      >
        {children()}
      </div>
      <Footer />
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js